import { DocFlowPhaseItemStatus } from '../DocFlow.constants'
import { isDocFlowPhaseResult } from '../DocFlow.utils.phases'

import { DocFlowProfileHeaderActionsBase } from './DocFlowProfileHeaderActionsBase'
import { DocFlowProfileHeaderActionsCombining } from './DocFlowProfileHeaderActionsCombining'
import { DocFlowProfileHeaderActionsSending } from './DocFlowProfileHeaderActionsSending'
import { DocFlowProfileHeaderActionsUploading } from './DocFlowProfileHeaderActionsUploading'

function DocFlowProfileHeaderActions({ selectedPhase, ...restProps }) {
  const isResultPhase = isDocFlowPhaseResult(selectedPhase)

  switch (selectedPhase) {
    case DocFlowPhaseItemStatus.Uploading:
      return <DocFlowProfileHeaderActionsUploading {...restProps} />
    case DocFlowPhaseItemStatus.Sending:
      return <DocFlowProfileHeaderActionsSending {...restProps} />
    case DocFlowPhaseItemStatus.Combining:
      return <DocFlowProfileHeaderActionsCombining {...restProps} />
    default:
      return (
        <DocFlowProfileHeaderActionsBase
          {...restProps}
          isResultPhase={isResultPhase}
        />
      )
  }
}

export default DocFlowProfileHeaderActions
